$(document).ready(function(){


    $('html').removeAttr("style");
    $("body").removeClass("preload");

    // Search Container - Trigger is in secondary-navigation.twig
    $(".search-trigger").on('click', function(e) {
        e.preventDefault();
        $(".search-container").toggleClass("active");
        if ($(".search-container").hasClass("active"))
        {
            setTimeout( function()
            { 
                $('#auto-search').focus();
            }, 250);
        }

    });

    $(".search-close").on('click', function(e) {
        e.preventDefault();
        $(".search-container").removeClass("active");
    });

    if ($('.fancybox').length)
    {
        $(".fancybox").fancybox(
            {
                beforeShow : function()
                {
                    this.title =  $(this.element).data("caption");
                },
                openEffect: "none",
                closeEffect: "none",

                helpers:
                    {
                        overlay:
                            {
                                css: { 'background': 'rgba(236, 236, 236, 0.8)' }
                            }
                    }
            });
    }


    // esc key action
    $(document).keyup(function(e) 
    {
        if (e.keyCode == 27) 
        { // Esc

            $('#featuredInfoWindow').slideUp(); // hide the faux infowindow on maps 
            $('#protectedDownloadsModal').modal('hide');

            $("html").removeClass("search-is-open");
            $("html").removeClass("nav-is-open");
            $("html").removeClass("aux-nav-is-open");

        }
    });


});
